function collapsible() {
    const elCollapsibleItems = document.querySelectorAll('[data-collapsible]');

    Array.from(elCollapsibleItems).forEach(function(el) {
        const elAction = el.querySelector('[data-collapsible-action]');
        elAction.addEventListener('click', function () {
            this.parentElement.classList.toggle('collapsed');
        })
    })
}

module.exports = {collapsible}
